import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Activity = {
  courses: Array<MilitaryCourse>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  source: FileType;
  specific: Scalars['Boolean']['output'];
  weight: Scalars['Float']['output'];
};

export enum AdvertisementSource {
  Aff = 'Aff',
  Astrumu = 'Astrumu',
  Ausa = 'Ausa',
  ClearanceJobs = 'ClearanceJobs',
  HiringOurHeroes = 'HiringOurHeroes',
  OperationMilitaryFamily = 'OperationMilitaryFamily',
  Other = 'Other',
  PmProlearn = 'PmProlearn',
  RecruitMilitary = 'RecruitMilitary',
  Tap = 'Tap',
  Umb = 'Umb'
}

export type AuthZDirectiveCompositeRulesInput = {
  and?: InputMaybe<Array<InputMaybe<AuthZRules>>>;
  not?: InputMaybe<AuthZRules>;
  or?: InputMaybe<Array<InputMaybe<AuthZRules>>>;
};

export type AuthZDirectiveDeepCompositeRulesInput = {
  and?: InputMaybe<Array<InputMaybe<AuthZDirectiveDeepCompositeRulesInput>>>;
  id?: InputMaybe<AuthZRules>;
  not?: InputMaybe<AuthZDirectiveDeepCompositeRulesInput>;
  or?: InputMaybe<Array<InputMaybe<AuthZDirectiveDeepCompositeRulesInput>>>;
};

export enum AuthZRules {
  IsAdminUser = 'IsAdminUser',
  IsAuthenticated = 'IsAuthenticated',
  IsCmsUser = 'IsCMSUser',
  IsFileOwner = 'IsFileOwner',
  IsReadySetUser = 'IsReadySetUser',
  IsWebhookGatewayQuery = 'IsWebhookGatewayQuery'
}

export type Award = {
  decode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Credential = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: CredentialType;
  url?: Maybe<Scalars['String']['output']>;
};

export type CredentialType = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CredentialTypeGroup = {
  selected: Array<CredentialType>;
  suggested: Array<CredentialType>;
};

export enum DegreeLevel {
  Associates = 'Associates',
  Bachelors = 'Bachelors',
  Doctoral = 'Doctoral',
  HighSchool = 'HighSchool',
  Masters = 'Masters'
}

export type DeliveryMethod = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DeliveryMethodGroup = {
  selected: Array<DeliveryMethod>;
  suggested: Array<DeliveryMethod>;
};

export type DurationGroup = {
  selected: Array<RangeFilterInt>;
  suggested: Array<RangeFilterInt>;
};

export type EducationAward = {
  id: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type File = {
  id: Scalars['String']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  originalName: Scalars['String']['output'];
  type: FileType;
  url: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export enum FileType {
  Jst = 'jst',
  Resume = 'resume',
  Srb = 'srb'
}

export enum Housing {
  OffPost = 'OffPost',
  OnPost = 'OnPost'
}

export type IspUser = {
  avatar?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastIp?: Maybe<Scalars['String']['output']>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  loginsCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type JobRecommendation = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  jobRole: JobRole;
  score: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type JobRecommendationInput = {
  jobRole: JobRoleInput;
};

export type JobRole = {
  activities: Array<Activity>;
  description?: Maybe<Scalars['String']['output']>;
  hardSkills: Array<Skill>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  skills: Array<Skill>;
  softSkills: Array<Skill>;
  standardJobTitles: Array<Scalars['String']['output']>;
  subtrack?: Maybe<Subtrack>;
};

export type JobRoleGroup = {
  selected: Array<JobRole>;
  suggested: Array<JobRole>;
};

export type JobRoleInput = {
  id: Scalars['String']['input'];
};

export enum JobRoleOrderingFields {
  ActivityIds = 'activityIds',
  Applications = 'applications',
  Description = 'description',
  HardSkillIds = 'hardSkillIds',
  Id = 'id',
  JobLevel = 'jobLevel',
  Name = 'name',
  Occupation = 'occupation',
  SoftSkillIds = 'softSkillIds',
  StandardJobTitles = 'standardJobTitles'
}

export type JobRoleWithJobRecommendation = {
  id: Scalars['String']['output'];
  jobRecommendation?: Maybe<JobRecommendation>;
  name: Scalars['String']['output'];
  occupation?: Maybe<Occupation>;
};

export type JobRolesWithJobRecommendationOrderingArgs = {
  direction?: OrderDirection;
  field?: JobRoleOrderingFields;
};

export type JstExperience = {
  aceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mosCode: Scalars['String']['output'];
  mosLevel: Scalars['String']['output'];
  mosType: Scalars['String']['output'];
  occupationId: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
};

export type JstFile = File & {
  id: Scalars['String']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  originalName: Scalars['String']['output'];
  type: FileType;
  url: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type LearningRecommendation = {
  baseProgram: Program;
  durationRange: RangeInt;
  id: Scalars['String']['output'];
  priceRange: RangeInt;
  programs: PaginatedPrograms;
  totalPrograms: Scalars['Int']['output'];
};


export type LearningRecommendationProgramsArgs = {
  order?: InputMaybe<LearningRecommendationProgramsOrderingArgs>;
  pagination?: OffsetPaginationArgs;
  query?: SearchLearningRecommendationProgramsInput;
};

export type LearningRecommendationFilters = {
  benefits: MilitaryBenefitGroup;
  credentialTypes: CredentialTypeGroup;
  deliveryMethods: DeliveryMethodGroup;
  duration: DurationGroup;
  jobRoles: JobRoleGroup;
  locations: LocationGroup;
  price: PriceGroup;
};


export type LearningRecommendationFiltersLocationsArgs = {
  excludeIds?: Array<Scalars['String']['input']>;
  jobRoleIds: Array<Scalars['String']['input']>;
  query?: Scalars['String']['input'];
};

export type LearningRecommendationProgramsOrderingArgs = {
  direction?: OrderDirection;
  field?: ProgramOrderingFields;
};

export type LearningRecommendationsOrderingArgs = {
  direction?: OrderDirection;
  field?: PaginatedLearningRecommendationsOrderingFields;
};

export type Link = {
  link: Scalars['String']['output'];
};

export type Location = {
  city: Scalars['String']['output'];
  id: Scalars['String']['output'];
  msaId: Scalars['String']['output'];
  /** Computed value combining city name and state name */
  name: Scalars['String']['output'];
  state: State;
};

export type LocationGroup = {
  selected: Array<Location>;
  suggested: Array<Location>;
};

export type Major = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum MaritalStatus {
  Divorced = 'Divorced',
  Married = 'Married',
  Single = 'Single'
}

export type MilitaryBase = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MilitaryBenefit = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MilitaryBenefitGroup = {
  selected: Array<MilitaryBenefit>;
  suggested: Array<MilitaryBenefit>;
};

export type MilitaryCourse = {
  aceId?: Maybe<Scalars['String']['output']>;
  activities: Array<Activity>;
  activityReplacementCourse?: Maybe<MilitaryCourse>;
  courseId?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  hardSkillReplacementCourse?: Maybe<MilitaryCourse>;
  hardSkills: Array<Skill>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rank?: Maybe<Array<Scalars['String']['output']>>;
  softSkillReplacementCourse?: Maybe<MilitaryCourse>;
  softSkills: Array<Skill>;
  source: FileType;
  srbCourse?: Maybe<Scalars['String']['output']>;
};

export type Mos = {
  aceId: Scalars['String']['output'];
  branchCode: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  designator: Scalars['Float']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inUse: Scalars['Boolean']['output'];
  mocCode: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  teamRevDate: Scalars['String']['output'];
  title: Scalars['String']['output'];
  version: Scalars['Float']['output'];
};

export type Mutation = {
  calculateJobRecommendations: Scalars['Boolean']['output'];
  changePassword: User;
  changePathwayJobRole: Pathway;
  deleteJst: Scalars['Boolean']['output'];
  deleteResume: Scalars['Boolean']['output'];
  deleteSrb: Scalars['Boolean']['output'];
  forgotPassword: Scalars['Boolean']['output'];
  recalculatePathways: Array<Pathway>;
  sendSkillsetSupportMessage: Scalars['Boolean']['output'];
  signup: User;
  toggleUserProgram: Program;
  updateUser: User;
  uploadJst: JstFile;
  uploadResume: ResumeFile;
  uploadSrb: SrbFile;
};


export type MutationChangePasswordArgs = {
  input: UserChangePasswordInput;
};


export type MutationChangePathwayJobRoleArgs = {
  input: PathwayJobRoleUpdateInput;
};


export type MutationDeleteJstArgs = {
  url: Scalars['String']['input'];
};


export type MutationDeleteResumeArgs = {
  url: Scalars['String']['input'];
};


export type MutationDeleteSrbArgs = {
  url: Scalars['String']['input'];
};


export type MutationRecalculatePathwaysArgs = {
  input: PathwaysRecalculateInput;
};


export type MutationSendSkillsetSupportMessageArgs = {
  input: SendMessageInput;
};


export type MutationSignupArgs = {
  input: UserCreateInput;
};


export type MutationToggleUserProgramArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  input: UserUpdateInput;
};


export type MutationUploadJstArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadResumeArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadSrbArgs = {
  file: Scalars['Upload']['input'];
};

export enum Occupation {
  LawEnforcement = 'LawEnforcement'
}

export type OffsetPaginationArgs = {
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PaginatedJobRolesWithJobRecommendation = {
  items: Array<JobRoleWithJobRecommendation>;
  total: Scalars['Int']['output'];
};

export type PaginatedLearningRecommendations = {
  items: Array<LearningRecommendation>;
  total: Scalars['Int']['output'];
};

export enum PaginatedLearningRecommendationsOrderingFields {
  Id = 'id',
  Name = 'name'
}

export type PaginatedPrograms = {
  items: Array<Program>;
  total: Scalars['Int']['output'];
};

export type Pathway = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  jobRecommendation: JobRecommendation;
  originalJobRecommendation: JobRecommendation;
  updatedAt: Scalars['DateTime']['output'];
};

export type PathwayJobRoleUpdateInput = {
  id: Scalars['String']['input'];
  jobRoleId: Scalars['String']['input'];
};

export type PathwaysInput = {
  jobRecommendation: JobRecommendationInput;
};

export type PathwaysRecalculateInput = {
  occupationsToExclude?: Array<Occupation>;
};

export type PayGrade = {
  id: Scalars['String']['output'];
};

export type PriceGroup = {
  selected: Array<RangeFilterFloat>;
  suggested: Array<RangeFilterFloat>;
};

export type Program = {
  activities: Array<Activity>;
  awardLevel?: Maybe<EducationAward>;
  benefits: Array<MilitaryBenefit>;
  costPeriod: Scalars['String']['output'];
  credential?: Maybe<Credential>;
  credentialType: CredentialType;
  deliveryMethods: Array<DeliveryMethod>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  isSaved: Scalars['Boolean']['output'];
  locations: Array<Location>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  major?: Maybe<Major>;
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  providerName: Scalars['String']['output'];
  relatedJobRoles: Array<JobRole>;
  skills: Array<Skill>;
  university?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ProgramOrderingFields {
  ActivityIds = 'activityIds',
  AwardLevelId = 'awardLevelId',
  BenefitIds = 'benefitIds',
  CostPeriod = 'costPeriod',
  CredentialId = 'credentialId',
  CredentialTypeId = 'credentialTypeId',
  DeliveryMethodIds = 'deliveryMethodIds',
  Description = 'description',
  Duration = 'duration',
  Id = 'id',
  LocationIds = 'locationIds',
  LogoUrl = 'logoUrl',
  MajorId = 'majorId',
  Name = 'name',
  Price = 'price',
  ProviderName = 'providerName',
  RelatedJobRoleIds = 'relatedJobRoleIds',
  SkillIds = 'skillIds',
  UniversityId = 'universityId',
  Url = 'url'
}

export type Query = {
  activity: Activity;
  autocompleteLocation: Array<Location>;
  award: Award;
  credential: Credential;
  credentialType: CredentialType;
  deliveryMethod: DeliveryMethod;
  educationAward: EducationAward;
  jobRecommendation: JobRecommendation;
  jobRole: JobRole;
  jstLink: Link;
  learningProgram: Program;
  learningRecommendation: LearningRecommendation;
  major: Major;
  me: User;
  militaryBase: MilitaryBase;
  militaryBenefit: MilitaryBenefit;
  militaryCourse: MilitaryCourse;
  mos: Mos;
  pathway: Pathway;
  payGrade: PayGrade;
  payGrades: Array<PayGrade>;
  resumeLink: Link;
  service: ServiceInfo;
  skill: Skill;
  state: State;
  stateByName: StateByName;
  suggestJobRoles: Array<JobRole>;
  suggestMajors: Array<Major>;
  suggestMilitaryBases: Array<MilitaryBase>;
  suggestMilitaryCourses: Array<MilitaryCourse>;
  suggestMosByMosCode: Array<Mos>;
  suggestMosByTitle: Array<Mos>;
  suggestSkills: Array<Skill>;
  suggestUniversities: Array<University>;
  university: University;
};


export type QueryActivityArgs = {
  id: Scalars['String']['input'];
};


export type QueryAutocompleteLocationArgs = {
  query: Scalars['String']['input'];
};


export type QueryAwardArgs = {
  id: Scalars['String']['input'];
};


export type QueryCredentialArgs = {
  id: Scalars['String']['input'];
};


export type QueryCredentialTypeArgs = {
  id: Scalars['String']['input'];
};


export type QueryDeliveryMethodArgs = {
  id: Scalars['String']['input'];
};


export type QueryEducationAwardArgs = {
  id: Scalars['String']['input'];
};


export type QueryJobRecommendationArgs = {
  id: Scalars['String']['input'];
};


export type QueryJobRoleArgs = {
  id: Scalars['String']['input'];
};


export type QueryJstLinkArgs = {
  url: Scalars['String']['input'];
};


export type QueryLearningProgramArgs = {
  id: Scalars['String']['input'];
};


export type QueryLearningRecommendationArgs = {
  id: Scalars['String']['input'];
};


export type QueryMajorArgs = {
  id: Scalars['String']['input'];
};


export type QueryMilitaryBaseArgs = {
  id: Scalars['String']['input'];
};


export type QueryMilitaryBenefitArgs = {
  id: Scalars['String']['input'];
};


export type QueryMilitaryCourseArgs = {
  id: Scalars['String']['input'];
};


export type QueryMosArgs = {
  id: Scalars['String']['input'];
};


export type QueryPathwayArgs = {
  id: Scalars['String']['input'];
};


export type QueryPayGradeArgs = {
  id: Scalars['String']['input'];
};


export type QueryResumeLinkArgs = {
  url: Scalars['String']['input'];
};


export type QuerySkillArgs = {
  id: Scalars['String']['input'];
};


export type QueryStateArgs = {
  id: Scalars['String']['input'];
};


export type QueryStateByNameArgs = {
  name: Scalars['String']['input'];
};


export type QuerySuggestJobRolesArgs = {
  query: Scalars['String']['input'];
};


export type QuerySuggestMajorsArgs = {
  query: Scalars['String']['input'];
};


export type QuerySuggestMilitaryBasesArgs = {
  query: Scalars['String']['input'];
};


export type QuerySuggestMilitaryCoursesArgs = {
  query: Scalars['String']['input'];
};


export type QuerySuggestMosByMosCodeArgs = {
  query: Scalars['String']['input'];
};


export type QuerySuggestMosByTitleArgs = {
  query: Scalars['String']['input'];
};


export type QuerySuggestSkillsArgs = {
  query: Scalars['String']['input'];
};


export type QuerySuggestUniversitiesArgs = {
  query: Scalars['String']['input'];
};


export type QueryUniversityArgs = {
  id: Scalars['String']['input'];
};

export type RangeFilterFloat = {
  from?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  to?: Maybe<Scalars['Float']['output']>;
};

export type RangeFilterInt = {
  from?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  to?: Maybe<Scalars['Int']['output']>;
};

export type RangeInt = {
  from?: Maybe<Scalars['Int']['output']>;
  to?: Maybe<Scalars['Int']['output']>;
};

export type ResumeFile = File & {
  id: Scalars['String']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  originalName: Scalars['String']['output'];
  type: FileType;
  url: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SearchJobRolesWithJobRecommendationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SearchLearningRecommendationProgramsInput = {
  awardLevelIds?: Array<Scalars['String']['input']>;
  benefitIds?: Array<Scalars['String']['input']>;
  credentialTypeIds?: Array<Scalars['String']['input']>;
  deliveryMethodIds?: Array<Scalars['String']['input']>;
  duration?: Array<SearchRangeFilterIntInput>;
  jobRoleIds?: Array<Scalars['String']['input']>;
  locationIds?: Array<Scalars['String']['input']>;
  price?: Array<SearchRangeFilterFloatInput>;
  providerOrLocationName?: InputMaybe<Scalars['String']['input']>;
};

export type SearchLearningRecommendationsInput = {
  awardLevelIds?: Array<Scalars['String']['input']>;
  benefitIds?: Array<Scalars['String']['input']>;
  credentialTypeIds?: Array<Scalars['String']['input']>;
  deliveryMethodIds?: Array<Scalars['String']['input']>;
  duration?: Array<SearchRangeFilterIntInput>;
  jobRoleIds?: Array<Scalars['String']['input']>;
  locationIds?: Array<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: Array<SearchRangeFilterFloatInput>;
};

export type SearchRangeFilterFloatInput = {
  from?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};

export type SearchRangeFilterIntInput = {
  from?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export type SendMessageInput = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceInfo = {
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type Skill = {
  courses: Array<MilitaryCourse>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  source: FileType;
  weight: Scalars['Float']['output'];
};

export type SrbFile = File & {
  id: Scalars['String']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  originalName: Scalars['String']['output'];
  type: FileType;
  url: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type State = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StateByName = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Subtrack = {
  id: Scalars['String']['output'];
};

export type University = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type User = IspUser & {
  activities: Array<Activity>;
  advertisementSource?: Maybe<AdvertisementSource>;
  armyStartDate?: Maybe<Scalars['DateTime']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentLocation?: Maybe<Location>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  degreeLevel?: Maybe<DegreeLevel>;
  desiredJobLocation?: Maybe<Location>;
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  experiences: Array<JstExperience>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  hardSkills: Array<Skill>;
  housing?: Maybe<Housing>;
  id: Scalars['String']['output'];
  isConsideringNationalReserve?: Maybe<Scalars['Boolean']['output']>;
  isHomeTourCompleted: Scalars['Boolean']['output'];
  jobRoles: Array<JobRole>;
  jobRolesWithJobRecommendations: PaginatedJobRolesWithJobRecommendation;
  jst?: Maybe<JstFile>;
  lastIp?: Maybe<Scalars['String']['output']>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  learningRecommendationFilters: LearningRecommendationFilters;
  learningRecommendations: PaginatedLearningRecommendations;
  linkedInURL?: Maybe<Scalars['String']['output']>;
  loginsCount?: Maybe<Scalars['Int']['output']>;
  majors: Array<Major>;
  maritalStatus?: Maybe<MaritalStatus>;
  militaryBases: Array<MilitaryBase>;
  militaryCourses: Array<MilitaryCourse>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  occupationsToExclude: Array<Occupation>;
  pathways: Array<Pathway>;
  payGrade?: Maybe<PayGrade>;
  phone: Scalars['String']['output'];
  resume?: Maybe<ResumeFile>;
  retirementDate?: Maybe<Scalars['DateTime']['output']>;
  savedPrograms: Array<Program>;
  srb?: Maybe<SrbFile>;
  transitionDate?: Maybe<Scalars['DateTime']['output']>;
  universities: Array<University>;
  updatedAt: Scalars['DateTime']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type UserJobRolesWithJobRecommendationsArgs = {
  order?: InputMaybe<JobRolesWithJobRecommendationOrderingArgs>;
  pagination?: OffsetPaginationArgs;
  query?: SearchJobRolesWithJobRecommendationInput;
};


export type UserLearningRecommendationFiltersArgs = {
  query?: SearchLearningRecommendationsInput;
};


export type UserLearningRecommendationsArgs = {
  order?: InputMaybe<LearningRecommendationsOrderingArgs>;
  pagination?: OffsetPaginationArgs;
  query?: SearchLearningRecommendationsInput;
};

export type UserChangePasswordInput = {
  email: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type UserCreateInput = {
  advertisementSource?: InputMaybe<AdvertisementSource>;
  consentProof: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UserLearningRecommendationMetadata = {
  degreeLevel?: InputMaybe<DegreeLevel>;
  id: Scalars['String']['input'];
  occupationsToExclude: Array<Occupation>;
  pathways: Array<PathwaysInput>;
};

export type UserMetadataInput = {
  id: Scalars['String']['input'];
};

export type UserUpdateInput = {
  armyStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  currentLocationId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  degreeLevel?: InputMaybe<DegreeLevel>;
  desiredJobLocationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  housing?: InputMaybe<Housing>;
  isConsideringNationalReserve?: InputMaybe<Scalars['Boolean']['input']>;
  isHomeTourCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  jobRoleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInURL?: InputMaybe<Scalars['String']['input']>;
  majorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  militaryBaseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  occupationsToExclude?: InputMaybe<Array<Occupation>>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  retirementDate?: InputMaybe<Scalars['DateTime']['input']>;
  transitionDate?: InputMaybe<Scalars['DateTime']['input']>;
  universityIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ContactSupportMutationVariables = Exact<{
  input: SendMessageInput;
}>;


export type ContactSupportMutation = { sendSkillsetSupportMessage: boolean };

export type CalculateJobRecommendationsMutationVariables = Exact<{ [key: string]: never; }>;


export type CalculateJobRecommendationsMutation = { calculateJobRecommendations: boolean };

export type UploadJstMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadJstMutation = { uploadJst: { id: string, url: string, userId: string, originalName: string } };

export type DeleteJstMutationVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type DeleteJstMutation = { deleteJst: boolean };

export type ToggleUserProgramMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ToggleUserProgramMutation = { toggleUserProgram: { id: string, isSaved: boolean } };

export type ChangePasswordMutationVariables = Exact<{
  input: UserChangePasswordInput;
}>;


export type ChangePasswordMutation = { changePassword: { id: string } };

export type ForgotPasswordMutationVariables = Exact<{ [key: string]: never; }>;


export type ForgotPasswordMutation = { forgotPassword: boolean };

export type ChangePathwayJobRoleMutationVariables = Exact<{
  input: PathwayJobRoleUpdateInput;
}>;


export type ChangePathwayJobRoleMutation = { changePathwayJobRole: { id: string } };

export type RecalculatePathwaysMutationVariables = Exact<{
  input: PathwaysRecalculateInput;
}>;


export type RecalculatePathwaysMutation = { recalculatePathways: Array<{ __typename: 'Pathway', id: string, originalJobRecommendation: { __typename: 'JobRecommendation', id: string, score: number, jobRole: { id: string, name: string } }, jobRecommendation: { __typename: 'JobRecommendation', id: string, score: number, jobRole: { id: string, name: string } } }> };

export type UploadResumeMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadResumeMutation = { uploadResume: { id: string, url: string, userId: string, originalName: string } };

export type DeleteResumeMutationVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type DeleteResumeMutation = { deleteResume: boolean };

export type UploadSrbMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadSrbMutation = { uploadSrb: { id: string, url: string, userId: string, originalName: string } };

export type DeleteSrbMutationVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type DeleteSrbMutation = { deleteSrb: boolean };

export type CreateUserMutationVariables = Exact<{
  input: UserCreateInput;
}>;


export type CreateUserMutation = { signup: { id: string, email: string } };

export type UpdateUserMutationVariables = Exact<{
  input: UserUpdateInput;
}>;


export type UpdateUserMutation = { updateUser: { id: string, isHomeTourCompleted: boolean, isConsideringNationalReserve?: boolean | null, transitionDate?: any | null, dateOfBirth?: any | null, housing?: Housing | null, occupationsToExclude: Array<Occupation>, linkedInURL?: string | null, resume?: { id: string, url: string, originalName: string } | null, jst?: { id: string, url: string, originalName: string } | null, srb?: { id: string, url: string, originalName: string } | null, currentLocation?: { id: string, name: string } | null, desiredJobLocation?: { id: string, name: string } | null } };

export type JobRecommendationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type JobRecommendationQuery = { jobRecommendation: { id: string, score: number, jobRole: { id: string, name: string, description?: string | null, standardJobTitles: Array<string>, activities: Array<{ id: string, name: string }>, hardSkills: Array<{ id: string, name: string }> } } };

export type SearchJobRecommendationsQueryVariables = Exact<{
  query?: InputMaybe<SearchJobRolesWithJobRecommendationInput>;
  pagination?: InputMaybe<OffsetPaginationArgs>;
  order?: InputMaybe<JobRolesWithJobRecommendationOrderingArgs>;
}>;


export type SearchJobRecommendationsQuery = { me: { id: string, jobRolesWithJobRecommendations: { total: number, items: Array<{ id: string, name: string, jobRecommendation?: { id: string, score: number } | null }> } } };

export type JobRoleQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type JobRoleQuery = { jobRole: { id: string, name: string, description?: string | null, standardJobTitles: Array<string>, activities: Array<{ id: string, name: string }>, hardSkills: Array<{ id: string, name: string }> } };

export type LearningProgramFragment = { id: string, name: string, providerName: string, price: number, description?: string | null, url?: string | null, logoUrl?: string | null, isSaved: boolean, duration?: number | null, credential?: { id: string, name: string } | null, skills: Array<{ id: string, name: string }>, activities: Array<{ id: string, name: string }>, locations: Array<{ id: string, name: string }> };

export type SavedProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type SavedProgramsQuery = { me: { id: string, savedPrograms: Array<{ id: string, name: string, providerName: string, price: number, description?: string | null, url?: string | null, logoUrl?: string | null, isSaved: boolean, duration?: number | null, credential?: { id: string, name: string } | null, skills: Array<{ id: string, name: string }>, activities: Array<{ id: string, name: string }>, locations: Array<{ id: string, name: string }> }> } };

export type LearningProgramQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LearningProgramQuery = { learningProgram: { id: string, name: string, providerName: string, price: number, description?: string | null, url?: string | null, logoUrl?: string | null, isSaved: boolean, duration?: number | null, credential?: { id: string, name: string } | null, skills: Array<{ id: string, name: string }>, activities: Array<{ id: string, name: string }>, locations: Array<{ id: string, name: string }> } };

export type LearningRecommendationsQueryVariables = Exact<{
  query: SearchLearningRecommendationsInput;
  pagination?: InputMaybe<OffsetPaginationArgs>;
  order?: InputMaybe<LearningRecommendationsOrderingArgs>;
}>;


export type LearningRecommendationsQuery = { me: { id: string, occupationsToExclude: Array<Occupation>, learningRecommendations: { total: number, items: Array<{ id: string, totalPrograms: number, durationRange: { from?: number | null, to?: number | null }, priceRange: { from?: number | null, to?: number | null }, baseProgram: { id: string, name: string, credential?: { id: string, name: string } | null, skills: Array<{ id: string }>, activities: Array<{ id: string }>, awardLevel?: { id: string, name: string, level: number } | null, credentialType: { id: string, name: string } } }> } } };

export type FiltersLocationsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  jobRoleIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  excludeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FiltersLocationsQuery = { me: { id: string, occupationsToExclude: Array<Occupation>, learningRecommendationFilters: { locations: { suggested: Array<{ id: string, name: string }>, selected: Array<{ id: string, name: string }> } } } };

export type LearningRecommendationFiltersQueryVariables = Exact<{
  query?: InputMaybe<SearchLearningRecommendationsInput>;
}>;


export type LearningRecommendationFiltersQuery = { me: { id: string, occupationsToExclude: Array<Occupation>, learningRecommendationFilters: { jobRoles: { suggested: Array<{ id: string, name: string }>, selected: Array<{ id: string, name: string }> }, benefits: { suggested: Array<{ id: string, name: string }>, selected: Array<{ id: string, name: string }> }, deliveryMethods: { suggested: Array<{ id: string, name: string }>, selected: Array<{ id: string, name: string }> }, price: { suggested: Array<{ id: string, from?: number | null, to?: number | null }>, selected: Array<{ id: string, from?: number | null, to?: number | null }> }, duration: { suggested: Array<{ id: string, from?: number | null, to?: number | null }>, selected: Array<{ id: string, from?: number | null, to?: number | null }> }, credentialTypes: { suggested: Array<{ id: string, name: string }>, selected: Array<{ id: string, name: string }> } } } };

export type LearningRecommendationIntroductionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LearningRecommendationIntroductionQuery = { learningRecommendation: { id: string, durationRange: { from?: number | null, to?: number | null }, baseProgram: { id: string, name: string, duration?: number | null, credential?: { id: string, name: string } | null, credentialType: { id: string, name: string }, awardLevel?: { id: string, name: string } | null } } };

export type LearningRecommendationProgramsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  programsQuery: SearchLearningRecommendationProgramsInput;
  pagination?: InputMaybe<OffsetPaginationArgs>;
  order?: InputMaybe<LearningRecommendationProgramsOrderingArgs>;
}>;


export type LearningRecommendationProgramsQuery = { learningRecommendation: { id: string, durationRange: { from?: number | null, to?: number | null }, programs: { total: number, items: Array<{ id: string, name: string, providerName: string, price: number, description?: string | null, url?: string | null, logoUrl?: string | null, isSaved: boolean, duration?: number | null, credential?: { id: string, name: string } | null, skills: Array<{ id: string, name: string }>, activities: Array<{ id: string, name: string }>, locations: Array<{ id: string, name: string }> }> } } };

export type LearningRecommendationSkillsetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LearningRecommendationSkillsetQuery = { learningRecommendation: { id: string, baseProgram: { id: string, skills: Array<{ id: string, name: string }>, activities: Array<{ id: string, name: string }> } } };

export type LearningRecommendationAboutQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LearningRecommendationAboutQuery = { learningRecommendation: { id: string, baseProgram: { id: string, description?: string | null } } };

export type SuggestLocationQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SuggestLocationQuery = { autocompleteLocation: Array<{ id: string, name: string }> };

export type MajorQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MajorQuery = { major: { id: string, name: string } };

export type SuggestMajorsQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SuggestMajorsQuery = { suggestMajors: Array<{ id: string, name: string }> };

export type SuggestMilitaryBasesQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SuggestMilitaryBasesQuery = { suggestMilitaryBases: Array<{ id: string, name: string }> };

export type SuggestMosQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SuggestMosQuery = { suggestMosByTitle: Array<{ id: string, title: string, mocCode: string }> };

export type PathwayJobRecommendationFragment = { __typename: 'JobRecommendation', id: string, score: number, jobRole: { id: string, name: string } };

export type PathwayFragment = { __typename: 'Pathway', id: string, originalJobRecommendation: { __typename: 'JobRecommendation', id: string, score: number, jobRole: { id: string, name: string } }, jobRecommendation: { __typename: 'JobRecommendation', id: string, score: number, jobRole: { id: string, name: string } } };

export type PathwaysQueryVariables = Exact<{ [key: string]: never; }>;


export type PathwaysQuery = { me: { id: string, pathways: Array<{ __typename: 'Pathway', id: string, originalJobRecommendation: { __typename: 'JobRecommendation', id: string, score: number, jobRole: { id: string, name: string } }, jobRecommendation: { __typename: 'JobRecommendation', id: string, score: number, jobRole: { id: string, name: string } } }> } };

export type PathwayQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PathwayQuery = { pathway: { __typename: 'Pathway', id: string, originalJobRecommendation: { __typename: 'JobRecommendation', id: string, score: number, jobRole: { id: string, name: string } }, jobRecommendation: { __typename: 'JobRecommendation', id: string, score: number, jobRole: { id: string, name: string } } } };

export type PayGradeQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PayGradeQuery = { payGrade: { id: string } };

export type PayGradesQueryVariables = Exact<{ [key: string]: never; }>;


export type PayGradesQuery = { payGrades: Array<{ id: string }> };

export type UniversityQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UniversityQuery = { university: { id: string, name: string } };

export type SuggestUniversitiesQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SuggestUniversitiesQuery = { suggestUniversities: Array<{ id: string, name: string }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me: { id: string, email: string, phone: string, avatar?: string | null, lastName: string, firstName: string, fullName: string, isHomeTourCompleted: boolean, dateOfBirth?: any | null, housing?: Housing | null, armyStartDate?: any | null, transitionDate?: any | null, retirementDate?: any | null, degreeLevel?: DegreeLevel | null, occupationsToExclude: Array<Occupation>, isConsideringNationalReserve?: boolean | null, linkedInURL?: string | null, majors: Array<{ id: string, name: string }>, universities: Array<{ id: string, name: string }>, experiences: Array<{ id: string, title: string, startDate: any }>, militaryCourses: Array<{ id: string, name: string, endDate: any }>, resume?: { id: string, url: string, originalName: string } | null, payGrade?: { id: string } | null, jst?: { id: string, url: string, originalName: string } | null, srb?: { id: string, url: string, originalName: string } | null, currentLocation?: { id: string, name: string } | null, desiredJobLocation?: { id: string, name: string } | null } };

export type UserSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSkillsQuery = { me: { __typename: 'User', id: string, hardSkills: Array<{ id: string, name: string, source: FileType, courses: Array<{ id: string, name: string, endDate: any }> }> } };

export type UserAbilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAbilitiesQuery = { me: { __typename: 'User', id: string, activities: Array<{ id: string, name: string, source: FileType, courses: Array<{ id: string, name: string, endDate: any }> }> } };

export const LearningProgramFragmentDoc = gql`
    fragment LearningProgram on Program {
  id
  name
  providerName
  price
  description
  url
  logoUrl
  isSaved
  duration
  credential {
    id
    name
  }
  skills {
    id
    name
  }
  activities {
    id
    name
  }
  locations {
    id
    name
  }
}
    `;
export const PathwayJobRecommendationFragmentDoc = gql`
    fragment PathwayJobRecommendation on JobRecommendation {
  __typename
  id
  score
  jobRole {
    id
    name
  }
}
    `;
export const PathwayFragmentDoc = gql`
    fragment Pathway on Pathway {
  __typename
  id
  originalJobRecommendation {
    ...PathwayJobRecommendation
  }
  jobRecommendation {
    ...PathwayJobRecommendation
  }
}
    ${PathwayJobRecommendationFragmentDoc}`;
export const ContactSupportDocument = gql`
    mutation contactSupport($input: SendMessageInput!) {
  sendSkillsetSupportMessage(input: $input)
}
    `;
export type ContactSupportMutationFn = Apollo.MutationFunction<ContactSupportMutation, ContactSupportMutationVariables>;

/**
 * __useContactSupportMutation__
 *
 * To run a mutation, you first call `useContactSupportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactSupportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactSupportMutation, { data, loading, error }] = useContactSupportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactSupportMutation(baseOptions?: Apollo.MutationHookOptions<ContactSupportMutation, ContactSupportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactSupportMutation, ContactSupportMutationVariables>(ContactSupportDocument, options);
      }
export type ContactSupportMutationHookResult = ReturnType<typeof useContactSupportMutation>;
export type ContactSupportMutationResult = Apollo.MutationResult<ContactSupportMutation>;
export type ContactSupportMutationOptions = Apollo.BaseMutationOptions<ContactSupportMutation, ContactSupportMutationVariables>;
export const CalculateJobRecommendationsDocument = gql`
    mutation calculateJobRecommendations {
  calculateJobRecommendations
}
    `;
export type CalculateJobRecommendationsMutationFn = Apollo.MutationFunction<CalculateJobRecommendationsMutation, CalculateJobRecommendationsMutationVariables>;

/**
 * __useCalculateJobRecommendationsMutation__
 *
 * To run a mutation, you first call `useCalculateJobRecommendationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateJobRecommendationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateJobRecommendationsMutation, { data, loading, error }] = useCalculateJobRecommendationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useCalculateJobRecommendationsMutation(baseOptions?: Apollo.MutationHookOptions<CalculateJobRecommendationsMutation, CalculateJobRecommendationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalculateJobRecommendationsMutation, CalculateJobRecommendationsMutationVariables>(CalculateJobRecommendationsDocument, options);
      }
export type CalculateJobRecommendationsMutationHookResult = ReturnType<typeof useCalculateJobRecommendationsMutation>;
export type CalculateJobRecommendationsMutationResult = Apollo.MutationResult<CalculateJobRecommendationsMutation>;
export type CalculateJobRecommendationsMutationOptions = Apollo.BaseMutationOptions<CalculateJobRecommendationsMutation, CalculateJobRecommendationsMutationVariables>;
export const UploadJstDocument = gql`
    mutation uploadJst($file: Upload!) {
  uploadJst(file: $file) {
    id
    url
    userId
    originalName
  }
}
    `;
export type UploadJstMutationFn = Apollo.MutationFunction<UploadJstMutation, UploadJstMutationVariables>;

/**
 * __useUploadJstMutation__
 *
 * To run a mutation, you first call `useUploadJstMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadJstMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadJstMutation, { data, loading, error }] = useUploadJstMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadJstMutation(baseOptions?: Apollo.MutationHookOptions<UploadJstMutation, UploadJstMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadJstMutation, UploadJstMutationVariables>(UploadJstDocument, options);
      }
export type UploadJstMutationHookResult = ReturnType<typeof useUploadJstMutation>;
export type UploadJstMutationResult = Apollo.MutationResult<UploadJstMutation>;
export type UploadJstMutationOptions = Apollo.BaseMutationOptions<UploadJstMutation, UploadJstMutationVariables>;
export const DeleteJstDocument = gql`
    mutation deleteJst($url: String!) {
  deleteJst(url: $url)
}
    `;
export type DeleteJstMutationFn = Apollo.MutationFunction<DeleteJstMutation, DeleteJstMutationVariables>;

/**
 * __useDeleteJstMutation__
 *
 * To run a mutation, you first call `useDeleteJstMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJstMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJstMutation, { data, loading, error }] = useDeleteJstMutation({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useDeleteJstMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJstMutation, DeleteJstMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJstMutation, DeleteJstMutationVariables>(DeleteJstDocument, options);
      }
export type DeleteJstMutationHookResult = ReturnType<typeof useDeleteJstMutation>;
export type DeleteJstMutationResult = Apollo.MutationResult<DeleteJstMutation>;
export type DeleteJstMutationOptions = Apollo.BaseMutationOptions<DeleteJstMutation, DeleteJstMutationVariables>;
export const ToggleUserProgramDocument = gql`
    mutation toggleUserProgram($id: String!) {
  toggleUserProgram(id: $id) {
    id
    isSaved
  }
}
    `;
export type ToggleUserProgramMutationFn = Apollo.MutationFunction<ToggleUserProgramMutation, ToggleUserProgramMutationVariables>;

/**
 * __useToggleUserProgramMutation__
 *
 * To run a mutation, you first call `useToggleUserProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUserProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUserProgramMutation, { data, loading, error }] = useToggleUserProgramMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleUserProgramMutation(baseOptions?: Apollo.MutationHookOptions<ToggleUserProgramMutation, ToggleUserProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleUserProgramMutation, ToggleUserProgramMutationVariables>(ToggleUserProgramDocument, options);
      }
export type ToggleUserProgramMutationHookResult = ReturnType<typeof useToggleUserProgramMutation>;
export type ToggleUserProgramMutationResult = Apollo.MutationResult<ToggleUserProgramMutation>;
export type ToggleUserProgramMutationOptions = Apollo.BaseMutationOptions<ToggleUserProgramMutation, ToggleUserProgramMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($input: UserChangePasswordInput!) {
  changePassword(input: $input) {
    id
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword {
  forgotPassword
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ChangePathwayJobRoleDocument = gql`
    mutation changePathwayJobRole($input: PathwayJobRoleUpdateInput!) {
  changePathwayJobRole(input: $input) {
    id
  }
}
    `;
export type ChangePathwayJobRoleMutationFn = Apollo.MutationFunction<ChangePathwayJobRoleMutation, ChangePathwayJobRoleMutationVariables>;

/**
 * __useChangePathwayJobRoleMutation__
 *
 * To run a mutation, you first call `useChangePathwayJobRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePathwayJobRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePathwayJobRoleMutation, { data, loading, error }] = useChangePathwayJobRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePathwayJobRoleMutation(baseOptions?: Apollo.MutationHookOptions<ChangePathwayJobRoleMutation, ChangePathwayJobRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePathwayJobRoleMutation, ChangePathwayJobRoleMutationVariables>(ChangePathwayJobRoleDocument, options);
      }
export type ChangePathwayJobRoleMutationHookResult = ReturnType<typeof useChangePathwayJobRoleMutation>;
export type ChangePathwayJobRoleMutationResult = Apollo.MutationResult<ChangePathwayJobRoleMutation>;
export type ChangePathwayJobRoleMutationOptions = Apollo.BaseMutationOptions<ChangePathwayJobRoleMutation, ChangePathwayJobRoleMutationVariables>;
export const RecalculatePathwaysDocument = gql`
    mutation recalculatePathways($input: PathwaysRecalculateInput!) {
  recalculatePathways(input: $input) {
    ...Pathway
  }
}
    ${PathwayFragmentDoc}`;
export type RecalculatePathwaysMutationFn = Apollo.MutationFunction<RecalculatePathwaysMutation, RecalculatePathwaysMutationVariables>;

/**
 * __useRecalculatePathwaysMutation__
 *
 * To run a mutation, you first call `useRecalculatePathwaysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecalculatePathwaysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recalculatePathwaysMutation, { data, loading, error }] = useRecalculatePathwaysMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecalculatePathwaysMutation(baseOptions?: Apollo.MutationHookOptions<RecalculatePathwaysMutation, RecalculatePathwaysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecalculatePathwaysMutation, RecalculatePathwaysMutationVariables>(RecalculatePathwaysDocument, options);
      }
export type RecalculatePathwaysMutationHookResult = ReturnType<typeof useRecalculatePathwaysMutation>;
export type RecalculatePathwaysMutationResult = Apollo.MutationResult<RecalculatePathwaysMutation>;
export type RecalculatePathwaysMutationOptions = Apollo.BaseMutationOptions<RecalculatePathwaysMutation, RecalculatePathwaysMutationVariables>;
export const UploadResumeDocument = gql`
    mutation uploadResume($file: Upload!) {
  uploadResume(file: $file) {
    id
    url
    userId
    originalName
  }
}
    `;
export type UploadResumeMutationFn = Apollo.MutationFunction<UploadResumeMutation, UploadResumeMutationVariables>;

/**
 * __useUploadResumeMutation__
 *
 * To run a mutation, you first call `useUploadResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadResumeMutation, { data, loading, error }] = useUploadResumeMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadResumeMutation(baseOptions?: Apollo.MutationHookOptions<UploadResumeMutation, UploadResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadResumeMutation, UploadResumeMutationVariables>(UploadResumeDocument, options);
      }
export type UploadResumeMutationHookResult = ReturnType<typeof useUploadResumeMutation>;
export type UploadResumeMutationResult = Apollo.MutationResult<UploadResumeMutation>;
export type UploadResumeMutationOptions = Apollo.BaseMutationOptions<UploadResumeMutation, UploadResumeMutationVariables>;
export const DeleteResumeDocument = gql`
    mutation deleteResume($url: String!) {
  deleteResume(url: $url)
}
    `;
export type DeleteResumeMutationFn = Apollo.MutationFunction<DeleteResumeMutation, DeleteResumeMutationVariables>;

/**
 * __useDeleteResumeMutation__
 *
 * To run a mutation, you first call `useDeleteResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResumeMutation, { data, loading, error }] = useDeleteResumeMutation({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useDeleteResumeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResumeMutation, DeleteResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResumeMutation, DeleteResumeMutationVariables>(DeleteResumeDocument, options);
      }
export type DeleteResumeMutationHookResult = ReturnType<typeof useDeleteResumeMutation>;
export type DeleteResumeMutationResult = Apollo.MutationResult<DeleteResumeMutation>;
export type DeleteResumeMutationOptions = Apollo.BaseMutationOptions<DeleteResumeMutation, DeleteResumeMutationVariables>;
export const UploadSrbDocument = gql`
    mutation uploadSrb($file: Upload!) {
  uploadSrb(file: $file) {
    id
    url
    userId
    originalName
  }
}
    `;
export type UploadSrbMutationFn = Apollo.MutationFunction<UploadSrbMutation, UploadSrbMutationVariables>;

/**
 * __useUploadSrbMutation__
 *
 * To run a mutation, you first call `useUploadSrbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadSrbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadSrbMutation, { data, loading, error }] = useUploadSrbMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadSrbMutation(baseOptions?: Apollo.MutationHookOptions<UploadSrbMutation, UploadSrbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadSrbMutation, UploadSrbMutationVariables>(UploadSrbDocument, options);
      }
export type UploadSrbMutationHookResult = ReturnType<typeof useUploadSrbMutation>;
export type UploadSrbMutationResult = Apollo.MutationResult<UploadSrbMutation>;
export type UploadSrbMutationOptions = Apollo.BaseMutationOptions<UploadSrbMutation, UploadSrbMutationVariables>;
export const DeleteSrbDocument = gql`
    mutation deleteSrb($url: String!) {
  deleteSrb(url: $url)
}
    `;
export type DeleteSrbMutationFn = Apollo.MutationFunction<DeleteSrbMutation, DeleteSrbMutationVariables>;

/**
 * __useDeleteSrbMutation__
 *
 * To run a mutation, you first call `useDeleteSrbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSrbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSrbMutation, { data, loading, error }] = useDeleteSrbMutation({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useDeleteSrbMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSrbMutation, DeleteSrbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSrbMutation, DeleteSrbMutationVariables>(DeleteSrbDocument, options);
      }
export type DeleteSrbMutationHookResult = ReturnType<typeof useDeleteSrbMutation>;
export type DeleteSrbMutationResult = Apollo.MutationResult<DeleteSrbMutation>;
export type DeleteSrbMutationOptions = Apollo.BaseMutationOptions<DeleteSrbMutation, DeleteSrbMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($input: UserCreateInput!) {
  signup(input: $input) {
    id
    email
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UserUpdateInput!) {
  updateUser(input: $input) {
    id
    isHomeTourCompleted
    isConsideringNationalReserve
    transitionDate
    dateOfBirth
    housing
    occupationsToExclude
    resume {
      id
      url
      originalName
    }
    jst {
      id
      url
      originalName
    }
    srb {
      id
      url
      originalName
    }
    linkedInURL
    currentLocation {
      id
      name
    }
    desiredJobLocation {
      id
      name
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const JobRecommendationDocument = gql`
    query jobRecommendation($id: String!) {
  jobRecommendation(id: $id) {
    id
    score
    jobRole {
      id
      name
      description
      standardJobTitles
      activities {
        id
        name
      }
      hardSkills {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useJobRecommendationQuery__
 *
 * To run a query within a React component, call `useJobRecommendationQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobRecommendationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobRecommendationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobRecommendationQuery(baseOptions: Apollo.QueryHookOptions<JobRecommendationQuery, JobRecommendationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobRecommendationQuery, JobRecommendationQueryVariables>(JobRecommendationDocument, options);
      }
export function useJobRecommendationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobRecommendationQuery, JobRecommendationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobRecommendationQuery, JobRecommendationQueryVariables>(JobRecommendationDocument, options);
        }
export function useJobRecommendationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobRecommendationQuery, JobRecommendationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobRecommendationQuery, JobRecommendationQueryVariables>(JobRecommendationDocument, options);
        }
export type JobRecommendationQueryHookResult = ReturnType<typeof useJobRecommendationQuery>;
export type JobRecommendationLazyQueryHookResult = ReturnType<typeof useJobRecommendationLazyQuery>;
export type JobRecommendationSuspenseQueryHookResult = ReturnType<typeof useJobRecommendationSuspenseQuery>;
export type JobRecommendationQueryResult = Apollo.QueryResult<JobRecommendationQuery, JobRecommendationQueryVariables>;
export const SearchJobRecommendationsDocument = gql`
    query searchJobRecommendations($query: SearchJobRolesWithJobRecommendationInput, $pagination: OffsetPaginationArgs, $order: JobRolesWithJobRecommendationOrderingArgs) {
  me {
    id
    jobRolesWithJobRecommendations(
      query: $query
      pagination: $pagination
      order: $order
    ) {
      total
      items {
        id
        name
        jobRecommendation {
          id
          score
        }
      }
    }
  }
}
    `;

/**
 * __useSearchJobRecommendationsQuery__
 *
 * To run a query within a React component, call `useSearchJobRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchJobRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchJobRecommendationsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchJobRecommendationsQuery(baseOptions?: Apollo.QueryHookOptions<SearchJobRecommendationsQuery, SearchJobRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchJobRecommendationsQuery, SearchJobRecommendationsQueryVariables>(SearchJobRecommendationsDocument, options);
      }
export function useSearchJobRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchJobRecommendationsQuery, SearchJobRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchJobRecommendationsQuery, SearchJobRecommendationsQueryVariables>(SearchJobRecommendationsDocument, options);
        }
export function useSearchJobRecommendationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchJobRecommendationsQuery, SearchJobRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchJobRecommendationsQuery, SearchJobRecommendationsQueryVariables>(SearchJobRecommendationsDocument, options);
        }
export type SearchJobRecommendationsQueryHookResult = ReturnType<typeof useSearchJobRecommendationsQuery>;
export type SearchJobRecommendationsLazyQueryHookResult = ReturnType<typeof useSearchJobRecommendationsLazyQuery>;
export type SearchJobRecommendationsSuspenseQueryHookResult = ReturnType<typeof useSearchJobRecommendationsSuspenseQuery>;
export type SearchJobRecommendationsQueryResult = Apollo.QueryResult<SearchJobRecommendationsQuery, SearchJobRecommendationsQueryVariables>;
export const JobRoleDocument = gql`
    query jobRole($id: String!) {
  jobRole(id: $id) {
    id
    name
    description
    standardJobTitles
    activities {
      id
      name
    }
    hardSkills {
      id
      name
    }
  }
}
    `;

/**
 * __useJobRoleQuery__
 *
 * To run a query within a React component, call `useJobRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobRoleQuery(baseOptions: Apollo.QueryHookOptions<JobRoleQuery, JobRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobRoleQuery, JobRoleQueryVariables>(JobRoleDocument, options);
      }
export function useJobRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobRoleQuery, JobRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobRoleQuery, JobRoleQueryVariables>(JobRoleDocument, options);
        }
export function useJobRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobRoleQuery, JobRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobRoleQuery, JobRoleQueryVariables>(JobRoleDocument, options);
        }
export type JobRoleQueryHookResult = ReturnType<typeof useJobRoleQuery>;
export type JobRoleLazyQueryHookResult = ReturnType<typeof useJobRoleLazyQuery>;
export type JobRoleSuspenseQueryHookResult = ReturnType<typeof useJobRoleSuspenseQuery>;
export type JobRoleQueryResult = Apollo.QueryResult<JobRoleQuery, JobRoleQueryVariables>;
export const SavedProgramsDocument = gql`
    query savedPrograms {
  me {
    id
    savedPrograms {
      ...LearningProgram
    }
  }
}
    ${LearningProgramFragmentDoc}`;

/**
 * __useSavedProgramsQuery__
 *
 * To run a query within a React component, call `useSavedProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSavedProgramsQuery(baseOptions?: Apollo.QueryHookOptions<SavedProgramsQuery, SavedProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedProgramsQuery, SavedProgramsQueryVariables>(SavedProgramsDocument, options);
      }
export function useSavedProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedProgramsQuery, SavedProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedProgramsQuery, SavedProgramsQueryVariables>(SavedProgramsDocument, options);
        }
export function useSavedProgramsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SavedProgramsQuery, SavedProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SavedProgramsQuery, SavedProgramsQueryVariables>(SavedProgramsDocument, options);
        }
export type SavedProgramsQueryHookResult = ReturnType<typeof useSavedProgramsQuery>;
export type SavedProgramsLazyQueryHookResult = ReturnType<typeof useSavedProgramsLazyQuery>;
export type SavedProgramsSuspenseQueryHookResult = ReturnType<typeof useSavedProgramsSuspenseQuery>;
export type SavedProgramsQueryResult = Apollo.QueryResult<SavedProgramsQuery, SavedProgramsQueryVariables>;
export const LearningProgramDocument = gql`
    query learningProgram($id: String!) {
  learningProgram(id: $id) {
    ...LearningProgram
  }
}
    ${LearningProgramFragmentDoc}`;

/**
 * __useLearningProgramQuery__
 *
 * To run a query within a React component, call `useLearningProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningProgramQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningProgramQuery(baseOptions: Apollo.QueryHookOptions<LearningProgramQuery, LearningProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningProgramQuery, LearningProgramQueryVariables>(LearningProgramDocument, options);
      }
export function useLearningProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningProgramQuery, LearningProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningProgramQuery, LearningProgramQueryVariables>(LearningProgramDocument, options);
        }
export function useLearningProgramSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningProgramQuery, LearningProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningProgramQuery, LearningProgramQueryVariables>(LearningProgramDocument, options);
        }
export type LearningProgramQueryHookResult = ReturnType<typeof useLearningProgramQuery>;
export type LearningProgramLazyQueryHookResult = ReturnType<typeof useLearningProgramLazyQuery>;
export type LearningProgramSuspenseQueryHookResult = ReturnType<typeof useLearningProgramSuspenseQuery>;
export type LearningProgramQueryResult = Apollo.QueryResult<LearningProgramQuery, LearningProgramQueryVariables>;
export const LearningRecommendationsDocument = gql`
    query learningRecommendations($query: SearchLearningRecommendationsInput!, $pagination: OffsetPaginationArgs, $order: LearningRecommendationsOrderingArgs) {
  me {
    id
    occupationsToExclude
    learningRecommendations(query: $query, pagination: $pagination, order: $order) {
      total
      items {
        id
        totalPrograms
        durationRange {
          from
          to
        }
        priceRange {
          from
          to
        }
        baseProgram {
          id
          name
          credential {
            id
            name
          }
          skills {
            id
          }
          activities {
            id
          }
          awardLevel {
            id
            name
            level
          }
          credentialType {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLearningRecommendationsQuery__
 *
 * To run a query within a React component, call `useLearningRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningRecommendationsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLearningRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>(LearningRecommendationsDocument, options);
      }
export function useLearningRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>(LearningRecommendationsDocument, options);
        }
export function useLearningRecommendationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>(LearningRecommendationsDocument, options);
        }
export type LearningRecommendationsQueryHookResult = ReturnType<typeof useLearningRecommendationsQuery>;
export type LearningRecommendationsLazyQueryHookResult = ReturnType<typeof useLearningRecommendationsLazyQuery>;
export type LearningRecommendationsSuspenseQueryHookResult = ReturnType<typeof useLearningRecommendationsSuspenseQuery>;
export type LearningRecommendationsQueryResult = Apollo.QueryResult<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>;
export const FiltersLocationsDocument = gql`
    query filtersLocations($query: String, $jobRoleIds: [String!]!, $excludeIds: [String!]) {
  me {
    id
    occupationsToExclude
    learningRecommendationFilters {
      locations(query: $query, jobRoleIds: $jobRoleIds, excludeIds: $excludeIds) {
        suggested {
          id
          name
        }
        selected {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFiltersLocationsQuery__
 *
 * To run a query within a React component, call `useFiltersLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiltersLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiltersLocationsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      jobRoleIds: // value for 'jobRoleIds'
 *      excludeIds: // value for 'excludeIds'
 *   },
 * });
 */
export function useFiltersLocationsQuery(baseOptions: Apollo.QueryHookOptions<FiltersLocationsQuery, FiltersLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FiltersLocationsQuery, FiltersLocationsQueryVariables>(FiltersLocationsDocument, options);
      }
export function useFiltersLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FiltersLocationsQuery, FiltersLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FiltersLocationsQuery, FiltersLocationsQueryVariables>(FiltersLocationsDocument, options);
        }
export function useFiltersLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FiltersLocationsQuery, FiltersLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FiltersLocationsQuery, FiltersLocationsQueryVariables>(FiltersLocationsDocument, options);
        }
export type FiltersLocationsQueryHookResult = ReturnType<typeof useFiltersLocationsQuery>;
export type FiltersLocationsLazyQueryHookResult = ReturnType<typeof useFiltersLocationsLazyQuery>;
export type FiltersLocationsSuspenseQueryHookResult = ReturnType<typeof useFiltersLocationsSuspenseQuery>;
export type FiltersLocationsQueryResult = Apollo.QueryResult<FiltersLocationsQuery, FiltersLocationsQueryVariables>;
export const LearningRecommendationFiltersDocument = gql`
    query learningRecommendationFilters($query: SearchLearningRecommendationsInput) {
  me {
    id
    occupationsToExclude
    learningRecommendationFilters(query: $query) {
      jobRoles {
        suggested {
          id
          name
        }
        selected {
          id
          name
        }
      }
      benefits {
        suggested {
          id
          name
        }
        selected {
          id
          name
        }
      }
      deliveryMethods {
        suggested {
          id
          name
        }
        selected {
          id
          name
        }
      }
      price {
        suggested {
          id
          from
          to
        }
        selected {
          id
          from
          to
        }
      }
      duration {
        suggested {
          id
          from
          to
        }
        selected {
          id
          from
          to
        }
      }
      credentialTypes {
        suggested {
          id
          name
        }
        selected {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useLearningRecommendationFiltersQuery__
 *
 * To run a query within a React component, call `useLearningRecommendationFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningRecommendationFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningRecommendationFiltersQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useLearningRecommendationFiltersQuery(baseOptions?: Apollo.QueryHookOptions<LearningRecommendationFiltersQuery, LearningRecommendationFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningRecommendationFiltersQuery, LearningRecommendationFiltersQueryVariables>(LearningRecommendationFiltersDocument, options);
      }
export function useLearningRecommendationFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningRecommendationFiltersQuery, LearningRecommendationFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningRecommendationFiltersQuery, LearningRecommendationFiltersQueryVariables>(LearningRecommendationFiltersDocument, options);
        }
export function useLearningRecommendationFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningRecommendationFiltersQuery, LearningRecommendationFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningRecommendationFiltersQuery, LearningRecommendationFiltersQueryVariables>(LearningRecommendationFiltersDocument, options);
        }
export type LearningRecommendationFiltersQueryHookResult = ReturnType<typeof useLearningRecommendationFiltersQuery>;
export type LearningRecommendationFiltersLazyQueryHookResult = ReturnType<typeof useLearningRecommendationFiltersLazyQuery>;
export type LearningRecommendationFiltersSuspenseQueryHookResult = ReturnType<typeof useLearningRecommendationFiltersSuspenseQuery>;
export type LearningRecommendationFiltersQueryResult = Apollo.QueryResult<LearningRecommendationFiltersQuery, LearningRecommendationFiltersQueryVariables>;
export const LearningRecommendationIntroductionDocument = gql`
    query learningRecommendationIntroduction($id: String!) {
  learningRecommendation(id: $id) {
    id
    durationRange {
      from
      to
    }
    baseProgram {
      id
      name
      duration
      credential {
        id
        name
      }
      credentialType {
        id
        name
      }
      awardLevel {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useLearningRecommendationIntroductionQuery__
 *
 * To run a query within a React component, call `useLearningRecommendationIntroductionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningRecommendationIntroductionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningRecommendationIntroductionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningRecommendationIntroductionQuery(baseOptions: Apollo.QueryHookOptions<LearningRecommendationIntroductionQuery, LearningRecommendationIntroductionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningRecommendationIntroductionQuery, LearningRecommendationIntroductionQueryVariables>(LearningRecommendationIntroductionDocument, options);
      }
export function useLearningRecommendationIntroductionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningRecommendationIntroductionQuery, LearningRecommendationIntroductionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningRecommendationIntroductionQuery, LearningRecommendationIntroductionQueryVariables>(LearningRecommendationIntroductionDocument, options);
        }
export function useLearningRecommendationIntroductionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningRecommendationIntroductionQuery, LearningRecommendationIntroductionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningRecommendationIntroductionQuery, LearningRecommendationIntroductionQueryVariables>(LearningRecommendationIntroductionDocument, options);
        }
export type LearningRecommendationIntroductionQueryHookResult = ReturnType<typeof useLearningRecommendationIntroductionQuery>;
export type LearningRecommendationIntroductionLazyQueryHookResult = ReturnType<typeof useLearningRecommendationIntroductionLazyQuery>;
export type LearningRecommendationIntroductionSuspenseQueryHookResult = ReturnType<typeof useLearningRecommendationIntroductionSuspenseQuery>;
export type LearningRecommendationIntroductionQueryResult = Apollo.QueryResult<LearningRecommendationIntroductionQuery, LearningRecommendationIntroductionQueryVariables>;
export const LearningRecommendationProgramsDocument = gql`
    query learningRecommendationPrograms($id: String!, $programsQuery: SearchLearningRecommendationProgramsInput!, $pagination: OffsetPaginationArgs, $order: LearningRecommendationProgramsOrderingArgs) {
  learningRecommendation(id: $id) {
    id
    durationRange {
      from
      to
    }
    programs(query: $programsQuery, pagination: $pagination, order: $order) {
      total
      items {
        ...LearningProgram
      }
    }
  }
}
    ${LearningProgramFragmentDoc}`;

/**
 * __useLearningRecommendationProgramsQuery__
 *
 * To run a query within a React component, call `useLearningRecommendationProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningRecommendationProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningRecommendationProgramsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      programsQuery: // value for 'programsQuery'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLearningRecommendationProgramsQuery(baseOptions: Apollo.QueryHookOptions<LearningRecommendationProgramsQuery, LearningRecommendationProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningRecommendationProgramsQuery, LearningRecommendationProgramsQueryVariables>(LearningRecommendationProgramsDocument, options);
      }
export function useLearningRecommendationProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningRecommendationProgramsQuery, LearningRecommendationProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningRecommendationProgramsQuery, LearningRecommendationProgramsQueryVariables>(LearningRecommendationProgramsDocument, options);
        }
export function useLearningRecommendationProgramsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningRecommendationProgramsQuery, LearningRecommendationProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningRecommendationProgramsQuery, LearningRecommendationProgramsQueryVariables>(LearningRecommendationProgramsDocument, options);
        }
export type LearningRecommendationProgramsQueryHookResult = ReturnType<typeof useLearningRecommendationProgramsQuery>;
export type LearningRecommendationProgramsLazyQueryHookResult = ReturnType<typeof useLearningRecommendationProgramsLazyQuery>;
export type LearningRecommendationProgramsSuspenseQueryHookResult = ReturnType<typeof useLearningRecommendationProgramsSuspenseQuery>;
export type LearningRecommendationProgramsQueryResult = Apollo.QueryResult<LearningRecommendationProgramsQuery, LearningRecommendationProgramsQueryVariables>;
export const LearningRecommendationSkillsetDocument = gql`
    query learningRecommendationSkillset($id: String!) {
  learningRecommendation(id: $id) {
    id
    baseProgram {
      id
      skills {
        id
        name
      }
      activities {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useLearningRecommendationSkillsetQuery__
 *
 * To run a query within a React component, call `useLearningRecommendationSkillsetQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningRecommendationSkillsetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningRecommendationSkillsetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningRecommendationSkillsetQuery(baseOptions: Apollo.QueryHookOptions<LearningRecommendationSkillsetQuery, LearningRecommendationSkillsetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningRecommendationSkillsetQuery, LearningRecommendationSkillsetQueryVariables>(LearningRecommendationSkillsetDocument, options);
      }
export function useLearningRecommendationSkillsetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningRecommendationSkillsetQuery, LearningRecommendationSkillsetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningRecommendationSkillsetQuery, LearningRecommendationSkillsetQueryVariables>(LearningRecommendationSkillsetDocument, options);
        }
export function useLearningRecommendationSkillsetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningRecommendationSkillsetQuery, LearningRecommendationSkillsetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningRecommendationSkillsetQuery, LearningRecommendationSkillsetQueryVariables>(LearningRecommendationSkillsetDocument, options);
        }
export type LearningRecommendationSkillsetQueryHookResult = ReturnType<typeof useLearningRecommendationSkillsetQuery>;
export type LearningRecommendationSkillsetLazyQueryHookResult = ReturnType<typeof useLearningRecommendationSkillsetLazyQuery>;
export type LearningRecommendationSkillsetSuspenseQueryHookResult = ReturnType<typeof useLearningRecommendationSkillsetSuspenseQuery>;
export type LearningRecommendationSkillsetQueryResult = Apollo.QueryResult<LearningRecommendationSkillsetQuery, LearningRecommendationSkillsetQueryVariables>;
export const LearningRecommendationAboutDocument = gql`
    query learningRecommendationAbout($id: String!) {
  learningRecommendation(id: $id) {
    id
    baseProgram {
      id
      description
    }
  }
}
    `;

/**
 * __useLearningRecommendationAboutQuery__
 *
 * To run a query within a React component, call `useLearningRecommendationAboutQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningRecommendationAboutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningRecommendationAboutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningRecommendationAboutQuery(baseOptions: Apollo.QueryHookOptions<LearningRecommendationAboutQuery, LearningRecommendationAboutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningRecommendationAboutQuery, LearningRecommendationAboutQueryVariables>(LearningRecommendationAboutDocument, options);
      }
export function useLearningRecommendationAboutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningRecommendationAboutQuery, LearningRecommendationAboutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningRecommendationAboutQuery, LearningRecommendationAboutQueryVariables>(LearningRecommendationAboutDocument, options);
        }
export function useLearningRecommendationAboutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningRecommendationAboutQuery, LearningRecommendationAboutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningRecommendationAboutQuery, LearningRecommendationAboutQueryVariables>(LearningRecommendationAboutDocument, options);
        }
export type LearningRecommendationAboutQueryHookResult = ReturnType<typeof useLearningRecommendationAboutQuery>;
export type LearningRecommendationAboutLazyQueryHookResult = ReturnType<typeof useLearningRecommendationAboutLazyQuery>;
export type LearningRecommendationAboutSuspenseQueryHookResult = ReturnType<typeof useLearningRecommendationAboutSuspenseQuery>;
export type LearningRecommendationAboutQueryResult = Apollo.QueryResult<LearningRecommendationAboutQuery, LearningRecommendationAboutQueryVariables>;
export const SuggestLocationDocument = gql`
    query suggestLocation($query: String!) {
  autocompleteLocation(query: $query) {
    id
    name
  }
}
    `;

/**
 * __useSuggestLocationQuery__
 *
 * To run a query within a React component, call `useSuggestLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestLocationQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSuggestLocationQuery(baseOptions: Apollo.QueryHookOptions<SuggestLocationQuery, SuggestLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestLocationQuery, SuggestLocationQueryVariables>(SuggestLocationDocument, options);
      }
export function useSuggestLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestLocationQuery, SuggestLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestLocationQuery, SuggestLocationQueryVariables>(SuggestLocationDocument, options);
        }
export function useSuggestLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuggestLocationQuery, SuggestLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestLocationQuery, SuggestLocationQueryVariables>(SuggestLocationDocument, options);
        }
export type SuggestLocationQueryHookResult = ReturnType<typeof useSuggestLocationQuery>;
export type SuggestLocationLazyQueryHookResult = ReturnType<typeof useSuggestLocationLazyQuery>;
export type SuggestLocationSuspenseQueryHookResult = ReturnType<typeof useSuggestLocationSuspenseQuery>;
export type SuggestLocationQueryResult = Apollo.QueryResult<SuggestLocationQuery, SuggestLocationQueryVariables>;
export const MajorDocument = gql`
    query major($id: String!) {
  major(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useMajorQuery__
 *
 * To run a query within a React component, call `useMajorQuery` and pass it any options that fit your needs.
 * When your component renders, `useMajorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMajorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMajorQuery(baseOptions: Apollo.QueryHookOptions<MajorQuery, MajorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MajorQuery, MajorQueryVariables>(MajorDocument, options);
      }
export function useMajorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MajorQuery, MajorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MajorQuery, MajorQueryVariables>(MajorDocument, options);
        }
export function useMajorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MajorQuery, MajorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MajorQuery, MajorQueryVariables>(MajorDocument, options);
        }
export type MajorQueryHookResult = ReturnType<typeof useMajorQuery>;
export type MajorLazyQueryHookResult = ReturnType<typeof useMajorLazyQuery>;
export type MajorSuspenseQueryHookResult = ReturnType<typeof useMajorSuspenseQuery>;
export type MajorQueryResult = Apollo.QueryResult<MajorQuery, MajorQueryVariables>;
export const SuggestMajorsDocument = gql`
    query suggestMajors($query: String!) {
  suggestMajors(query: $query) {
    id
    name
  }
}
    `;

/**
 * __useSuggestMajorsQuery__
 *
 * To run a query within a React component, call `useSuggestMajorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestMajorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestMajorsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSuggestMajorsQuery(baseOptions: Apollo.QueryHookOptions<SuggestMajorsQuery, SuggestMajorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestMajorsQuery, SuggestMajorsQueryVariables>(SuggestMajorsDocument, options);
      }
export function useSuggestMajorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestMajorsQuery, SuggestMajorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestMajorsQuery, SuggestMajorsQueryVariables>(SuggestMajorsDocument, options);
        }
export function useSuggestMajorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuggestMajorsQuery, SuggestMajorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestMajorsQuery, SuggestMajorsQueryVariables>(SuggestMajorsDocument, options);
        }
export type SuggestMajorsQueryHookResult = ReturnType<typeof useSuggestMajorsQuery>;
export type SuggestMajorsLazyQueryHookResult = ReturnType<typeof useSuggestMajorsLazyQuery>;
export type SuggestMajorsSuspenseQueryHookResult = ReturnType<typeof useSuggestMajorsSuspenseQuery>;
export type SuggestMajorsQueryResult = Apollo.QueryResult<SuggestMajorsQuery, SuggestMajorsQueryVariables>;
export const SuggestMilitaryBasesDocument = gql`
    query suggestMilitaryBases($query: String!) {
  suggestMilitaryBases(query: $query) {
    id
    name
  }
}
    `;

/**
 * __useSuggestMilitaryBasesQuery__
 *
 * To run a query within a React component, call `useSuggestMilitaryBasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestMilitaryBasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestMilitaryBasesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSuggestMilitaryBasesQuery(baseOptions: Apollo.QueryHookOptions<SuggestMilitaryBasesQuery, SuggestMilitaryBasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestMilitaryBasesQuery, SuggestMilitaryBasesQueryVariables>(SuggestMilitaryBasesDocument, options);
      }
export function useSuggestMilitaryBasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestMilitaryBasesQuery, SuggestMilitaryBasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestMilitaryBasesQuery, SuggestMilitaryBasesQueryVariables>(SuggestMilitaryBasesDocument, options);
        }
export function useSuggestMilitaryBasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuggestMilitaryBasesQuery, SuggestMilitaryBasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestMilitaryBasesQuery, SuggestMilitaryBasesQueryVariables>(SuggestMilitaryBasesDocument, options);
        }
export type SuggestMilitaryBasesQueryHookResult = ReturnType<typeof useSuggestMilitaryBasesQuery>;
export type SuggestMilitaryBasesLazyQueryHookResult = ReturnType<typeof useSuggestMilitaryBasesLazyQuery>;
export type SuggestMilitaryBasesSuspenseQueryHookResult = ReturnType<typeof useSuggestMilitaryBasesSuspenseQuery>;
export type SuggestMilitaryBasesQueryResult = Apollo.QueryResult<SuggestMilitaryBasesQuery, SuggestMilitaryBasesQueryVariables>;
export const SuggestMosDocument = gql`
    query suggestMOS($query: String!) {
  suggestMosByTitle(query: $query) {
    id
    title
    mocCode
  }
}
    `;

/**
 * __useSuggestMosQuery__
 *
 * To run a query within a React component, call `useSuggestMosQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestMosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestMosQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSuggestMosQuery(baseOptions: Apollo.QueryHookOptions<SuggestMosQuery, SuggestMosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestMosQuery, SuggestMosQueryVariables>(SuggestMosDocument, options);
      }
export function useSuggestMosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestMosQuery, SuggestMosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestMosQuery, SuggestMosQueryVariables>(SuggestMosDocument, options);
        }
export function useSuggestMosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuggestMosQuery, SuggestMosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestMosQuery, SuggestMosQueryVariables>(SuggestMosDocument, options);
        }
export type SuggestMosQueryHookResult = ReturnType<typeof useSuggestMosQuery>;
export type SuggestMosLazyQueryHookResult = ReturnType<typeof useSuggestMosLazyQuery>;
export type SuggestMosSuspenseQueryHookResult = ReturnType<typeof useSuggestMosSuspenseQuery>;
export type SuggestMosQueryResult = Apollo.QueryResult<SuggestMosQuery, SuggestMosQueryVariables>;
export const PathwaysDocument = gql`
    query pathways {
  me {
    id
    pathways {
      ...Pathway
    }
  }
}
    ${PathwayFragmentDoc}`;

/**
 * __usePathwaysQuery__
 *
 * To run a query within a React component, call `usePathwaysQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwaysQuery({
 *   variables: {
 *   },
 * });
 */
export function usePathwaysQuery(baseOptions?: Apollo.QueryHookOptions<PathwaysQuery, PathwaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PathwaysQuery, PathwaysQueryVariables>(PathwaysDocument, options);
      }
export function usePathwaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PathwaysQuery, PathwaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PathwaysQuery, PathwaysQueryVariables>(PathwaysDocument, options);
        }
export function usePathwaysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PathwaysQuery, PathwaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PathwaysQuery, PathwaysQueryVariables>(PathwaysDocument, options);
        }
export type PathwaysQueryHookResult = ReturnType<typeof usePathwaysQuery>;
export type PathwaysLazyQueryHookResult = ReturnType<typeof usePathwaysLazyQuery>;
export type PathwaysSuspenseQueryHookResult = ReturnType<typeof usePathwaysSuspenseQuery>;
export type PathwaysQueryResult = Apollo.QueryResult<PathwaysQuery, PathwaysQueryVariables>;
export const PathwayDocument = gql`
    query pathway($id: String!) {
  pathway(id: $id) {
    ...Pathway
  }
}
    ${PathwayFragmentDoc}`;

/**
 * __usePathwayQuery__
 *
 * To run a query within a React component, call `usePathwayQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwayQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePathwayQuery(baseOptions: Apollo.QueryHookOptions<PathwayQuery, PathwayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PathwayQuery, PathwayQueryVariables>(PathwayDocument, options);
      }
export function usePathwayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PathwayQuery, PathwayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PathwayQuery, PathwayQueryVariables>(PathwayDocument, options);
        }
export function usePathwaySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PathwayQuery, PathwayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PathwayQuery, PathwayQueryVariables>(PathwayDocument, options);
        }
export type PathwayQueryHookResult = ReturnType<typeof usePathwayQuery>;
export type PathwayLazyQueryHookResult = ReturnType<typeof usePathwayLazyQuery>;
export type PathwaySuspenseQueryHookResult = ReturnType<typeof usePathwaySuspenseQuery>;
export type PathwayQueryResult = Apollo.QueryResult<PathwayQuery, PathwayQueryVariables>;
export const PayGradeDocument = gql`
    query payGrade($id: String!) {
  payGrade(id: $id) {
    id
  }
}
    `;

/**
 * __usePayGradeQuery__
 *
 * To run a query within a React component, call `usePayGradeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayGradeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayGradeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePayGradeQuery(baseOptions: Apollo.QueryHookOptions<PayGradeQuery, PayGradeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayGradeQuery, PayGradeQueryVariables>(PayGradeDocument, options);
      }
export function usePayGradeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayGradeQuery, PayGradeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayGradeQuery, PayGradeQueryVariables>(PayGradeDocument, options);
        }
export function usePayGradeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PayGradeQuery, PayGradeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayGradeQuery, PayGradeQueryVariables>(PayGradeDocument, options);
        }
export type PayGradeQueryHookResult = ReturnType<typeof usePayGradeQuery>;
export type PayGradeLazyQueryHookResult = ReturnType<typeof usePayGradeLazyQuery>;
export type PayGradeSuspenseQueryHookResult = ReturnType<typeof usePayGradeSuspenseQuery>;
export type PayGradeQueryResult = Apollo.QueryResult<PayGradeQuery, PayGradeQueryVariables>;
export const PayGradesDocument = gql`
    query payGrades {
  payGrades {
    id
  }
}
    `;

/**
 * __usePayGradesQuery__
 *
 * To run a query within a React component, call `usePayGradesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayGradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayGradesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePayGradesQuery(baseOptions?: Apollo.QueryHookOptions<PayGradesQuery, PayGradesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayGradesQuery, PayGradesQueryVariables>(PayGradesDocument, options);
      }
export function usePayGradesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayGradesQuery, PayGradesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayGradesQuery, PayGradesQueryVariables>(PayGradesDocument, options);
        }
export function usePayGradesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PayGradesQuery, PayGradesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayGradesQuery, PayGradesQueryVariables>(PayGradesDocument, options);
        }
export type PayGradesQueryHookResult = ReturnType<typeof usePayGradesQuery>;
export type PayGradesLazyQueryHookResult = ReturnType<typeof usePayGradesLazyQuery>;
export type PayGradesSuspenseQueryHookResult = ReturnType<typeof usePayGradesSuspenseQuery>;
export type PayGradesQueryResult = Apollo.QueryResult<PayGradesQuery, PayGradesQueryVariables>;
export const UniversityDocument = gql`
    query university($id: String!) {
  university(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useUniversityQuery__
 *
 * To run a query within a React component, call `useUniversityQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniversityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniversityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUniversityQuery(baseOptions: Apollo.QueryHookOptions<UniversityQuery, UniversityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniversityQuery, UniversityQueryVariables>(UniversityDocument, options);
      }
export function useUniversityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniversityQuery, UniversityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniversityQuery, UniversityQueryVariables>(UniversityDocument, options);
        }
export function useUniversitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UniversityQuery, UniversityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UniversityQuery, UniversityQueryVariables>(UniversityDocument, options);
        }
export type UniversityQueryHookResult = ReturnType<typeof useUniversityQuery>;
export type UniversityLazyQueryHookResult = ReturnType<typeof useUniversityLazyQuery>;
export type UniversitySuspenseQueryHookResult = ReturnType<typeof useUniversitySuspenseQuery>;
export type UniversityQueryResult = Apollo.QueryResult<UniversityQuery, UniversityQueryVariables>;
export const SuggestUniversitiesDocument = gql`
    query suggestUniversities($query: String!) {
  suggestUniversities(query: $query) {
    id
    name
  }
}
    `;

/**
 * __useSuggestUniversitiesQuery__
 *
 * To run a query within a React component, call `useSuggestUniversitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestUniversitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestUniversitiesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSuggestUniversitiesQuery(baseOptions: Apollo.QueryHookOptions<SuggestUniversitiesQuery, SuggestUniversitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestUniversitiesQuery, SuggestUniversitiesQueryVariables>(SuggestUniversitiesDocument, options);
      }
export function useSuggestUniversitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestUniversitiesQuery, SuggestUniversitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestUniversitiesQuery, SuggestUniversitiesQueryVariables>(SuggestUniversitiesDocument, options);
        }
export function useSuggestUniversitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuggestUniversitiesQuery, SuggestUniversitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestUniversitiesQuery, SuggestUniversitiesQueryVariables>(SuggestUniversitiesDocument, options);
        }
export type SuggestUniversitiesQueryHookResult = ReturnType<typeof useSuggestUniversitiesQuery>;
export type SuggestUniversitiesLazyQueryHookResult = ReturnType<typeof useSuggestUniversitiesLazyQuery>;
export type SuggestUniversitiesSuspenseQueryHookResult = ReturnType<typeof useSuggestUniversitiesSuspenseQuery>;
export type SuggestUniversitiesQueryResult = Apollo.QueryResult<SuggestUniversitiesQuery, SuggestUniversitiesQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    id
    email
    phone
    avatar
    lastName
    firstName
    fullName
    isHomeTourCompleted
    dateOfBirth
    housing
    armyStartDate
    transitionDate
    retirementDate
    degreeLevel
    occupationsToExclude
    majors {
      id
      name
    }
    universities {
      id
      name
    }
    experiences {
      id
      title
      startDate
    }
    militaryCourses {
      id
      name
      endDate
    }
    isConsideringNationalReserve
    resume {
      id
      url
      originalName
    }
    experiences {
      id
      title
    }
    payGrade {
      id
    }
    jst {
      id
      url
      originalName
    }
    srb {
      id
      url
      originalName
    }
    linkedInURL
    currentLocation {
      id
      name
    }
    desiredJobLocation {
      id
      name
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UserSkillsDocument = gql`
    query userSkills {
  me {
    __typename
    id
    hardSkills {
      id
      name
      source
      courses {
        id
        name
        endDate
      }
    }
  }
}
    `;

/**
 * __useUserSkillsQuery__
 *
 * To run a query within a React component, call `useUserSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSkillsQuery(baseOptions?: Apollo.QueryHookOptions<UserSkillsQuery, UserSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSkillsQuery, UserSkillsQueryVariables>(UserSkillsDocument, options);
      }
export function useUserSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSkillsQuery, UserSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSkillsQuery, UserSkillsQueryVariables>(UserSkillsDocument, options);
        }
export function useUserSkillsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserSkillsQuery, UserSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserSkillsQuery, UserSkillsQueryVariables>(UserSkillsDocument, options);
        }
export type UserSkillsQueryHookResult = ReturnType<typeof useUserSkillsQuery>;
export type UserSkillsLazyQueryHookResult = ReturnType<typeof useUserSkillsLazyQuery>;
export type UserSkillsSuspenseQueryHookResult = ReturnType<typeof useUserSkillsSuspenseQuery>;
export type UserSkillsQueryResult = Apollo.QueryResult<UserSkillsQuery, UserSkillsQueryVariables>;
export const UserAbilitiesDocument = gql`
    query userAbilities {
  me {
    __typename
    id
    activities {
      id
      name
      source
      courses {
        id
        name
        endDate
      }
    }
  }
}
    `;

/**
 * __useUserAbilitiesQuery__
 *
 * To run a query within a React component, call `useUserAbilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAbilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAbilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserAbilitiesQuery(baseOptions?: Apollo.QueryHookOptions<UserAbilitiesQuery, UserAbilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAbilitiesQuery, UserAbilitiesQueryVariables>(UserAbilitiesDocument, options);
      }
export function useUserAbilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAbilitiesQuery, UserAbilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAbilitiesQuery, UserAbilitiesQueryVariables>(UserAbilitiesDocument, options);
        }
export function useUserAbilitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserAbilitiesQuery, UserAbilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserAbilitiesQuery, UserAbilitiesQueryVariables>(UserAbilitiesDocument, options);
        }
export type UserAbilitiesQueryHookResult = ReturnType<typeof useUserAbilitiesQuery>;
export type UserAbilitiesLazyQueryHookResult = ReturnType<typeof useUserAbilitiesLazyQuery>;
export type UserAbilitiesSuspenseQueryHookResult = ReturnType<typeof useUserAbilitiesSuspenseQuery>;
export type UserAbilitiesQueryResult = Apollo.QueryResult<UserAbilitiesQuery, UserAbilitiesQueryVariables>;
export const namedOperations = {
  Query: {
    jobRecommendation: 'jobRecommendation',
    searchJobRecommendations: 'searchJobRecommendations',
    jobRole: 'jobRole',
    savedPrograms: 'savedPrograms',
    learningProgram: 'learningProgram',
    learningRecommendations: 'learningRecommendations',
    filtersLocations: 'filtersLocations',
    learningRecommendationFilters: 'learningRecommendationFilters',
    learningRecommendationIntroduction: 'learningRecommendationIntroduction',
    learningRecommendationPrograms: 'learningRecommendationPrograms',
    learningRecommendationSkillset: 'learningRecommendationSkillset',
    learningRecommendationAbout: 'learningRecommendationAbout',
    suggestLocation: 'suggestLocation',
    major: 'major',
    suggestMajors: 'suggestMajors',
    suggestMilitaryBases: 'suggestMilitaryBases',
    suggestMOS: 'suggestMOS',
    pathways: 'pathways',
    pathway: 'pathway',
    payGrade: 'payGrade',
    payGrades: 'payGrades',
    university: 'university',
    suggestUniversities: 'suggestUniversities',
    me: 'me',
    userSkills: 'userSkills',
    userAbilities: 'userAbilities'
  },
  Mutation: {
    contactSupport: 'contactSupport',
    calculateJobRecommendations: 'calculateJobRecommendations',
    uploadJst: 'uploadJst',
    deleteJst: 'deleteJst',
    toggleUserProgram: 'toggleUserProgram',
    changePassword: 'changePassword',
    forgotPassword: 'forgotPassword',
    changePathwayJobRole: 'changePathwayJobRole',
    recalculatePathways: 'recalculatePathways',
    uploadResume: 'uploadResume',
    deleteResume: 'deleteResume',
    uploadSrb: 'uploadSrb',
    deleteSrb: 'deleteSrb',
    createUser: 'createUser',
    updateUser: 'updateUser'
  },
  Fragment: {
    LearningProgram: 'LearningProgram',
    PathwayJobRecommendation: 'PathwayJobRecommendation',
    Pathway: 'Pathway'
  }
}